// export const BASE_URL = "/dashboard/";
export const BASE_URL = "/banners/";
export const LOGIN_URL = "/signin";
export const BASE_TITLE = " CoE";

export const CONFIG = {
  layout: "vertical",
  collapseMenu: false,
  layoutType: "menu-dark",
};
